class GeocodeService {
  async getCityCoordinatesAsync(city: string, country: string) {
    await google.maps.importLibrary("geocoding");
    const geocoder = new google.maps.Geocoder();
    const response = await geocoder.geocode({ address: `${city} ${country}` });
    return response.results[0].geometry.location;
  }
}

export default GeocodeService;
